import { registerPlugin } from '@capacitor/core';
const SwipeBackControl = registerPlugin('SwipeBackControl', {
    web: () => import('./web').then((m) => new m.SwipeBackControlWeb()),
});
export * from './definitions';
export { SwipeBackControl };
//# sourceMappingURL=index.js.map